import React, { useEffect, useState } from "react";
import Product from "../product";
import { Container, Flex, Row } from "../../layouts";
import { Title } from "../../layouts/layouts";
import { RelatedProductsContainer } from "./layouts";
import { useExtrasData } from "../../Contexts/ExtrasContext";

const RelatedProducts = ({ data }) => {
  const [relatedData, setRelatedData] = useState([]);
  const { extrasData } = useExtrasData();

  useEffect(() => {
    if (data) {
      setRelatedData(data);
    }
  }, [data]);

  if (!data) return;

  return (
    <RelatedProductsContainer>
      <Container>
        <Flex className="flex-column mb-50 mb-md-30">
          {extrasData && <Title>{extrasData.relatedProductsTitle}</Title>}
        </Flex>
        {data && (
          <Row className="w-full mr-0 ml-0">
            {relatedData.map((product, index) => {
              return (
                <Product
                  data={product}
                  key={index}
                  size="col-6 col-lg-3 col-xl-3"
                />
              );
            })}
          </Row>
        )}
      </Container>
    </RelatedProductsContainer>
  );
};

export default RelatedProducts;
